import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const ChannelSchema_ = createEnum(["REDO", "EBAY", "POSHMARK"]);
export const ChannelSchema = ChannelSchema_;
export type Channel = z.infer<typeof ChannelSchema_>;

export const ChannelEnum = ChannelSchema_.enum;

export const ChannelDisplayNames: Record<Channel, string> = {
  [ChannelEnum.EBAY]: "eBay",
  [ChannelEnum.POSHMARK]: "Poshmark",
  [ChannelEnum.REDO]: "Redo",
};
